import axios from 'axios';
import apiConfig from '../api.config';

export default function hotelsRequest(page, size, filters, sort) {
  const {
    host,
    URIs: { hotels },
  } = apiConfig;

  var filter = { page, size, ...filters };
  if (sort) filter.order = sort;

  const uri = `${host}${hotels}?filter=${JSON.stringify(filter)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
